<script setup>
const { isMobile, isDesktop } = useDevice();


const data = await import(
  `../../../public/content/services/development-services/nft-token-development-content.json`
);

useHead({
  title: data?.meta_tags?.title || "",
  meta: data?.meta_tags?.meta || [],
});

const visible = ref(false);

const openModal = () => {
  visible.value = true;
};
</script>

<template>
  <section class="max-w-screen-xl px-4 mx-auto md:mt-10">
    <div class="flex max-md:flex-col justify-between gap-10">
      <WrServicesHeroSection
        :heading="data?.header.heading"
        :description="data?.header.text"
        :src="data?.header.image"
        :alt="data?.header.heading"
        width="497"
        height="429"
        @open-modal="openModal"
      />
    </div>
  </section>

  <!--We'll walk you through the  Starts-->
  <section class="dark:bg-none py-10 lg:py-20">
    <div class="max-w-screen-xl mx-auto px-4">
      <h2 class="lg:text-center">
        <WrGradientText>
          {{ data.development_process.heading }}
        </WrGradientText>
      </h2>
      <div
        class="max-w-screen-lg mx-auto lg:text-center lg:text-xl tracking-[0.5px] mb-10"
        v-html="data.development_process.subheading"
      ></div>
      <!--Section | Our e-commerce solutions to operational needs. Starts-->
      <WrStepper
        :steps="data.development_process.steps"
        :layout="isMobile ? 'mobile' : 'desktop'"
      />
    </div>
  </section>
  <!--We'll walk you through the  Ends-->

  <!--Why NFTs may be the future of the token economy Starts-->
  <section class="dark:bg-none py-20 lg:py-36">
    <div class="max-w-screen-xl px-4 mx-auto">
      <WrServicesPromiseSection
        :data="data?.our_promises"
        width="565"
        height="423"
      />
    </div>
  </section>

  <section class="px-4 xl:mt-20 mt-16 mb-16 relative z-10">
    <div
      class="max-w-screen-xl mx-auto m-4 lg:grid lg:grid-cols-[1fr_3fr] lg:gap-4"
    >
      <WrFeatureGridSection :data="data?.build_team" @open-modal="openModal" />
    </div>
  </section>

  <section class="dark:bg-none text-center py10 px-4">
    <div class="max-w-screen-xl mx-auto px-4 lg:pt-10 lg:pb-16">
      <h1>
        <WrGradientText> {{ data.our_services.heading }} </WrGradientText>
      </h1>
      <p class="text-lg tracking-[0.5px]">
        {{ data.our_services.subheading }}
      </p>
    </div>
  </section>

  <section class="dark:bg-none dark:even:bg-none">
    <div class="max-w-screen-xl mx-auto px-4">
      <WrOnboarding :onboarding="data.our_services.services" />
    </div>
  </section>

  <section class="dark:bg-none text-center py-20 px-4">
    <div class="max-w-screen-xl px-4 mx-auto">
      <div
        class="flex max-lg:flex-col items-center justify-between gap-10 lg:gap-20 lg:*:w-1/2"
      >
        <NuxtImg
          :src="data.development_team_content.image"
          :alt="data.development_team_content.heading"
          width="565"
          class="min-w-max [box-shadow:0_2rem_3rem_-1rem_rgba(105,124,161,0.16),0_0_0_0.5rem_#fff] rounded-2xl"
          loading="lazy"
          format="webp"
        />
        <div class="">
          <h2 class="text-2xl md:text-4xl mb-2 max-md:mb-4 md:mb-4">
            <WrGradientText
              :text="data.development_team_content.heading"
              append-class="pb-0 md:pb-2 bg-clip-text bg-[linear-gradient(92.15deg,_var(--text-gradient-1)_-1.57%,_var(--text-gradient-2)_30.72%)]"
            />
          </h2>
          <div
            class="lg:text-lg tracking-[0.5px] leading-[1.8]"
            v-html="data.development_team_content.subheading"
          ></div>
          <ul class="list-disc mt-4 px-6 marker:text-[#6d6685]">
            <li
              v-for="item in data.development_team_content.items"
              class="mt-4"
            >
              <h5 class="font-semibold text-xl">{{ item.heading }}</h5>
              <p>{{ item.description }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section>
    <div
      class="max-w-screen-xl mx-auto px-4 w-full grid md:grid-cols-2 gap-6 relative z-10 pb-10 lg:pb-24 mt-20"
    >
      <div
        class="size-[322px] absolute top-40 left-10 rounded-full blur-[150px] bg-[linear-gradient(180deg,_rgba(73,2,166,0.2)_0%,_rgba(255,164,235,0.2)_100%)]"
      ></div>
      <div class="max-md:text-center mx-auto max-w-[504px] z-10 relative">
        <h3>
          <WrGradientText
            text="Get all your questions"
            append-class="py-0 md:py-4"
          />
          <span>answered here</span>
        </h3>
        <p class="mt-5 pr-4 text-lg tracking-[0.5px]">
          {{ data.faq.subheading }}
        </p>
      </div>
      <div class="grow">
        <WrAccordion :Content="data.faq.content" />
      </div>
    </div>
  </section>
  <!--  Frequently asked questions Ends-->

  <!-- We have many more resources Starts-->
  <section class="max-w-screen-xl mx-auto px-4 py-6">
    <h2 class="lg:text-center">
      <WrGradientText append-class="leading-[1]">
        {{ data.other_services.side_box.heading }}
      </WrGradientText>
    </h2>
    <p
      class="max-w-screen-md mx-auto lg:text-lg lg:text-center tracking-[0.5px] mb-5 mt-2"
    >
      {{ data.other_services.side_box.subheading }}
    </p>
    <WrFrameworksCarousel />
  </section>
  <!-- We have many more resources Ends-->

  <!-- Testimonials Starts-->
  <section
    class="relative py-10 lg:py-20 overflow-hidden max-w-screen-xl mx-auto px-4 z-20"
  >
    <h2 class="text-center">
      <WrGradientText text="Trusted for excellence and efficiency" />
    </h2>
    <p
      class="text-lg text-[var(--foreground)] mb-10 text-center tracking-[0.5px]"
    >
      Webreinvent is trusted by leading organisations to enhance their
      development and operational efficiency.
    </p>
    <!-- Carousel Section -->

    <WrTestimonialCardCarousel />

    <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-2"
      >View All</WrButton
    >
  </section>
  <!-- Testimonials Ends-->
  <!-- Modal -->
  <WrContactFormPopup :isOpen="visible" @close="visible = false" class="z-30" />
</template>
